import {getSession} from "./amplify/amplify";
import {tryGetTokenFromAmplifyState} from "./amplify/amplify_state";

export interface IrequestData {
  url: string
  query?: string
  mutation?: string
  operationName?: string
  token?:string
  id_token?:string
  variables?: {[key:string]: any}
}

interface IbodyData {
  query?: string,
  mutation?: string,
  operationName?: string,
  variables?: {[key:string]: any}
}

export const graphqlRequest = async (data: IrequestData):Promise<{data:any, errors: Error[]}> => {
  let result, errors: Error[] = []
  const url = data.url
  const body:IbodyData = {}

  let token = data.token

  if (!token) {
    token = tryGetTokenFromAmplifyState(localStorage)
  }

  if (data.query) body.query = data.query
  if (data.mutation) body.mutation = data.mutation
  if (data.operationName) body.operationName = data.operationName
  if (data.variables) body.variables = data.variables
  const headers: any = {
    'Content-Type': 'application/json',
    'authorization': `Bearer ${token}`,
  }
  if (data.id_token) {
    headers["id-token"] = data.id_token
  }

  if (!token || !url || !(body.query || body.mutation)) throw new Error('unvalid data')
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers,
      body: JSON.stringify(body),
    });
    const json = await response.json();

    if (json.errors) {
      throw new Error(json.errors.map((err: any) => err.message).join(', '));
    }

    result = json

  } catch (err: unknown) {
    if (err instanceof Error) {
      errors.push(err); //
    } else {
      errors.push(new Error("An unknown error occurred"));
    }
  } finally {
    return {
      data: result,
      errors
    }
  }
}
